import { heroEquipment } from "../HeroEquipment";

export const mors = {
  heroes: {
    Szponowład: {
      id: 0,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Zbrojne stado klanu Mors"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 4, 3, 3, 2, 5, 1, 7],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Dowodzenie", "Dowódca", "Ranger", "Strachliwy", "W nogi!"],
      exp: 20,
      skills: [0, 1, 3, 4, 5],
    },
    "Szary prorok": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Zbrojne stado klanu Mors"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 4, 1, 7],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Czarnoksięstwo",
        "Mag (Tradycja Spaczmagii)",
        "Rafinacja Spaczenia",
        "Ranger",
        "W nogi!",
      ],
      exp: 12,
      skills: [0, 2, 4, 5],
    },
    Czarnoszczur: {
      id: 2,
      startingEquipment: ["Sztylet", "Halabarda"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Zbrojne stado klanu Mors"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 4, 3, 3, 3, 1, 5, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Krzepki", "Podoficer", "Ranger", "W nogi!", "Zimnokrwisty"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    "Łowca niewolników": {
      id: 3,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Zbrojne stado klanu Mors"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 5, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Handlarz niewolników", "Ranger", "W nogi!"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Klanbrat: {
      id: 5,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Zbrojne stado klanu Mors"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 3, 3, 3, 3, 1, 4, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Ranger",
        "W nogi!",
      ],
    },
    Szturmoszczur: {
      id: 6,
      startingEquipment: ["Sztylet", "Halabarda"],
      cost: 35,
      number: 5,
      equipmentList: heroEquipment["Zbrojne stado klanu Mors"].Szturmoszczur,
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 3, 4, 3, 1, 5, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Krzepki", "Ranger", "W nogi!"],
    },
    "Wielki szczur": {
      id: 7,
      startingEquipment: ["Broń naturalna"],
      cost: 15,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 2, 0, 3, 3, 1, 4, 1, 3],
        Maksymalna: [6, 2, 0, 3, 3, 1, 4, 1, 3],
      },
      rules: [
        "Murołaz",
        "Rozmiar rzondzi",
        "Sfora",
        "W nogi!",
        "Wodny",
        "Zwierzę",
      ],
    },

    Więźniarka: {
      id: 8,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Wilkoszczur: [9, 3, 0, 3, "-", "-", 4, 1, 3],
        "Wilkoszczur ": [9, 3, 0, 3, "-", "-", 4, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
    "Wóz bojowy": {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Wilkoszczur: [9, 3, 0, 3, "-", "-", 4, 1, 3],
        "Wilkoszczur ": [9, 3, 0, 3, "-", "-", 4, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Wóz bojowy"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Zbrojne stado klanu Mors",
  nature: "Chaotyczna",
  armyRules: ["Rozrzutność"],
  mercenaries: [
    "Czarownica",
    "Gladiator",
    "Hiena cmentarna",
    "Rozbójnik",
    "Szczurogr",
    "Szpieg",
    "Wróżbita",
    "Złodziej",
  ],
};
